export default __webpack_public_path__ + "static/media/06.6bf47dd6.jpg";